import React from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { get } from 'lodash';
import SahamDrawer from 'components/SahamDrawer';
import { translate } from 'containers/services/translate';
import messages from 'containers/LawyerFeeNote/messages';

import { ContainerInDrawer } from 'containers/LawyerFeeNote/styled-components';
import FeeNoteForm from 'containers/LawyerFeeNote/FeeNoteForm';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import { constructExceptionnelFeeNoteToAdd } from 'containers/LawyerFeeNote/utils';
import currentIntervenantStorage from 'containers/services/security/current-intervenant-storage';

export interface FeeNoteDrawerProps {
  intl: IntlShape;
  feeNote: any;
  open: boolean;
  handleSubmit: Function;
  handleToggleDrawer: Function;
  isManager: boolean;
  //UPLOAD PROPS
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  setDocumentId: Function;
  documentId: string;
  limitInvoiceDate: any;
}

const FeeNoteDrawer: React.FC<FeeNoteDrawerProps> = (props): JSX.Element => {
  let [feeNote, setFeeNote] = React.useState({
    ...props.feeNote,
    updatedAt: new Date(),
  });
  let [invoiceNumber, setInvoiceNumber] = React.useState(null);
  let [invoiceDate, setInvoiceDate] = React.useState(null);
  let [invoiceReceptionDate, setInvoiceReceptionDate] = React.useState(null);

  const [decisionValidation, setDecisionValidation] = React.useState(false);

  const handleChange = (feeNote: any) => {
    setFeeNote(feeNote);
  };

  const handleValidation = () => {
    props.handleSubmit(
      constructExceptionnelFeeNoteToAdd(
        feeNote,
        props.isManager,
        invoiceNumber,
        invoiceDate,
        invoiceReceptionDate,
      ),
    );
    props.handleToggleDrawer();
  };

  return (
    <SahamDrawer
      open={props.open}
      handleToggleDrawer={props.handleToggleDrawer}
      title={
        props.isManager
          ? translate({ ...messages.feeNoteDrawerTitle }, props, {
              number: null,
            })
          : translate({ ...messages.feeNoteLawyerDrawerTitle }, props)
      }
      handleValidateDrawer={handleValidation}
      confirmButtonTitle={translate(messages.saveBtn, props)}
      isSaveButtonDisabled={!decisionValidation}
    >
      <ContainerInDrawer>
        <FeeNoteForm
          feeNote={feeNote}
          isManager={props.isManager}
          handleDrawerChange={handleChange}
          uploadDocument={props.uploadDocument}
          uploadedDocument={props.uploadedDocument}
          resetUploadedDocument={props.resetUploadedDocument}
          setDocumentId={props.setDocumentId}
          documentId={props.documentId}
          updateValidation={setDecisionValidation}
          isIntervenant={currentIntervenantStorage?.get() ? true : false}
          invoiceNumber={invoiceNumber}
          invoiceDate={invoiceDate}
          setInvoiceNumber={setInvoiceNumber}
          setInvoiceDate={setInvoiceDate}
          invoiceReceptionDate={invoiceReceptionDate}
          setInvoiceReceptionDate={setInvoiceReceptionDate}
          limitInvoiceDate={props.limitInvoiceDate}
        />
      </ContainerInDrawer>
    </SahamDrawer>
  );
};

export default injectIntl(FeeNoteDrawer);
